<div class="company-edit-profile light-grey-background pb-60">
    <div class="container">

            <div class="row">
                <div class="col-lg-12 mx-auto">
                    <!--Server Response-->
                    <app-form-message [success]="formResponse" *ngIf="formSent" [customErrorMessage]=customErrorMessage [customSuccessMessage]="customSuccessMessage"></app-form-message>
                </div>
        </div>

        <form (ngSubmit)="onSubmit(changePassword)" #changePassword="ngForm" class="password-change">
            <div class="form-row">
                <div class="col-md-12 form-group">
                    <input type="password" id="oldPassword" class="form-control"  name="oldPassword" #oldPassword="ngModel"  placeholder="{{'LOGIN.OLD_PASSWORD' | translate}}" ngModel required>
                    <span class="help-block" *ngIf="!oldPassword.valid && (oldPassword.touched || changePassword.submitted)">{{'VALIDATION.OLD_PASSWORD' | translate}}</span>
                </div>
                <div class="col-md-12 form-group">
                    <input type="password" id="newPassword" class="form-control"  name="newPassword" #newPassword="ngModel"  placeholder="{{'LOGIN.NEW_PASSWROD' | translate}}" ngModel required [pattern]="pwdPattern">
                    <span class="help-block" *ngIf="!newPassword.valid && (newPassword.touched|| changePassword.submitted)">{{'VALIDATION.PASSWORD_REQ' | translate}}</span>
                </div>
                <button type="submit" class="green-button">{{'BUTTONS.SEND' | translate}}</button>
            </div>
        </form>

    </div>
</div>
